// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../styles/variables.css\"","textDefault":"#808080","container":"cG-cUih5QSVTomy0HBVO9","formWrapper":"_2CYKlNLYhtpLqUck5Yg9XA","title":"_1K7TplQrfS2JILJWhcuAdp","recover":"_1d2o19UImaj0lO9aKmdEJa","buttons":"_20gJ5XMtbP2ad5nGkkPW6_","link":"_325H6Fk4GkRYUiwZxyiAn3","message":"_2_P8Cm-wdozT351nBvz_-9"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PasswordRecovery/PasswordRecovery.mod.css
// module id = 599
// module chunks = 0